<template>
	<div id="app">
		<keep-alive include="GroupInfo">
			<router-view :key="$route.fullPath" />
		</keep-alive>
	</div>
</template>
<script>
export default {
  name: 'App',
  computed: {
    // :TODO: 暂时用不到，后面如果扩展，获取路由做缓存的方法
    keepAlive () {
      return this.$router
    }
  }
}
</script>

<style lang="stylus">
  html, body
    -webkit-overflow-scrolling touch
    -webkit-touch-callout: none
  #app
    position relative
    height 100%
    safe-area-mixin(padding-bottom , bottom)
</style>
